import { LOCALE_COOKIE, LOCALE_MAX_AGE } from './constants'

/**
 * Single source of truth for UI languages. Labels are native names so a user can
 * find their language without reading the current one. Client-safe (no next/headers).
 */
export const LOCALE_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'de', label: 'Deutsch' },
  { code: 'zh', label: '简体中文' },
  { code: 'th', label: 'ไทย' },
] as const

export type AppLocale = (typeof LOCALE_OPTIONS)[number]['code']

export const LOCALE_CODES: readonly AppLocale[] = LOCALE_OPTIONS.map((option) => option.code)

export function getLocaleLabel(code: string): string {
  return LOCALE_OPTIONS.find((option) => option.code === code)?.label ?? code
}

/** Persist the choice; callers then `router.refresh()` so server components re-render. */
export function writeLocaleCookie(locale: AppLocale): void {
  document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; max-age=${LOCALE_MAX_AGE}; samesite=lax`
}
